import { AuthActionType } from '../action-types';
import { AuthAction } from '../actions';

interface AuthState {
  loading: boolean;
  error: string | null;
  data: { accessToken: string | null; modules: string[]; redirectPath?: string; userRole?: string };
}

const initialState = {
  loading: false,
  error: null,
  data: { accessToken: null, modules: [] },
};

const reducer = (state: AuthState = initialState, action: AuthAction): AuthState => {
  switch (action.type) {
    case AuthActionType.SIGNIN:
      return { loading: true, error: null, data: state.data };
    case AuthActionType.SIGNIN_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case AuthActionType.SIGNIN_FAILURE:
      return { loading: false, error: action.payload, data: initialState.data };
    default:
      return state;
  }
};

export default reducer;
